import {create} from "zustand";
import { persist } from "zustand/middleware";

export const useProject = create(
  persist(
    (set, get) => ({
      projectDocs: null,
      projectDoc: null,
      _hasHydrated: false,
      setProjectDoc: (projectDoc) => {
        set({ projectDoc });
      },
      setProjectDocs: (projectDocs) => {
        set({ projectDocs });
      },
      getProjectBySlug: (slug) => {
        return get().projectDocs ? get().projectDocs.find(projectDoc => projectDoc.slug === slug) : null
      },
      updateProjectDocs: (projectDoc) => {
        set({ projectDocs: [projectDoc, ...get().projectDocs ] });
      },
      unsetProject: (projectId) => {
        set({ projectDocs: get().projectDocs.filter((p) => p.id !== projectId)});
      },
      setHasHydrated: (state) => {
        set({
          _hasHydrated: state,
        });
      },
    }),
    {
      name: "project-storage",
      getStorage: () => localStorage,
      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
